var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 522.7 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m257.95,279.85c-.9-1.2-1.5-2.2-1.7-2.8-.1-.3-.2-.5-.2-.6V112.02C256.05,50.11,205.94,0,144.03,0S32.01,50.21,32.01,112.02v164.53c0,.1-.1.3-.2.6-.2.6-.8,1.6-1.7,2.8C11.2,304.26,0,334.87,0,368.07c0,79.52,64.52,143.93,144.03,143.93s144.03-64.51,144.03-144.03c0-33.1-11.2-63.71-30.11-88.12Zm-43.38,163.77c-5.37,5.43-11.42,10.13-17.99,13.96-20.82,12.15-41.5,12.67-49.43,12.34-8.26-.35-14.7-7.36-14.35-15.62.22-5.13,3-9.74,7.43-12.32,2.48-1.45,5.31-2.15,8.19-2.03,4.13.18,18.7.1,33-8.24,4.3-2.51,8.28-5.6,11.81-9.17,14.8-14.98,16.8-33.16,16.97-40.29.13-5.25,2.91-9.96,7.44-12.6,2.4-1.4,5.13-2.1,7.91-2.04,8.27.2,14.84,7.09,14.64,15.35-.26,10.71-3.27,38.04-25.62,60.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.25,113.8c9.62,0,17.41,7.8,17.41,17.41v137.9l28.32-28.32c6.65-6.34,17.03-6.6,23.97-.58,3.37,3.11,5.31,7.48,5.34,12.07.07,5.28-2.03,10.36-5.8,14.05l-32.15,32.1c-11.61,11.61-22.81,17.7-34.42,18.4-12.98.84-25.68-3.98-34.82-13.23l-37.49-37.26c-6.85-6.67-7.43-17.48-1.33-24.84,3.19-3.57,7.7-5.66,12.48-5.8,4.79-.19,9.43,1.66,12.77,5.11l28.32,28.32v-137.9c0-9.62,7.8-17.41,17.41-17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.29,398.2h-121.88c-9.62,0-17.41-7.8-17.41-17.41s7.8-17.41,17.41-17.41h121.88c9.62,0,17.41,7.8,17.41,17.41s-7.8,17.41-17.41,17.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmin);
export default __webpack_public_path__ + "static/media/tmin.27d32b19ff544ac46ed33417066a3c72.svg";
export { ForwardRef as ReactComponent };